import React from "react"
import "./styles.css"

import SkillItem from "../../molecules/SkillItem"

const SkillContainer = (props) => {
    const { skills, skillLevel, handleClickDisplayInfoSkill, handleClickUpdateSkill } = props
    return <ul className="build-container">{skills.map((skill, index) => {
        return (
            <SkillItem
                key={skill.logoId}
                skill={skill}
                skillIndex={index}
                skillLevel={skillLevel[index]}
                handleClickDisplayInfoSkill={handleClickDisplayInfoSkill}
                handleClickUpdateSkill={handleClickUpdateSkill}
            />
        )
    })}</ul>
}

export default React.memo(SkillContainer)
